<template>
    <div class="page">
        <div class="group-select-title fadeInDown animated" v-if="!select">
            <van-image :src="groupSelectTitleImage" fit="cover" />
        </div>
        <div class="group-select" v-if="!select">
            <div class="three fadeInLeft animated">
                <img src="../assets/images/three_single.png">
            </div>
            <div class="one fadeInLeft animated">
                <img src="../assets/images/one_single.png">
            </div>
            <div class="two fadeInRight animated">
                <img src="../assets/images/two_single.png">
            </div>
        </div>
        <div class="hand-group-select" v-else>
            <div v-for="(image, key, index) in selectSingleImage" :key="index" :class="key" :style="imageIndex === key ? 'z-index: 202;position:relative' : ''">
                <img v-if="key === imageIndex" :src="image">
                <img v-else :src="singleImage[key]">
            </div>
        </div>

        <div class="select-cover" v-if="select"></div>

        <div class="people-position">
            <div class="three" @click="clickPeople('three')"></div>
            <div class="one" @click="clickPeople('one')"></div>
            <div class="two" @click="clickPeople('two')"></div>
        </div>

        <div class="select-btn" v-if="select">
            <img src="../assets/images/select_btn_girl.png" @click="handleSelectPeople" v-if="imageIndex === 'one'">
            <img src="../assets/images/select_btn.png" @click="handleSelectPeople" v-else>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';
    import { Image, Swipe, SwipeItem } from 'vant';

    export default {
        name: 'Guide',
        components: {
            [Image.name]: Image,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem
        },
        data () {
            return {
                imageIndex: 'one',
                select: false,
                groupSelectTitleImage: require('../assets/images/group_select_title.png'),
                singleImage: {
                    three: require('../assets/images/three_single.png'),
                    one: require('../assets/images/one_single.png'),
                    two: require('../assets/images/two_single.png')
                },
                selectSingleImage: {
                    three: require('../assets/images/three_single_select.png'),
                    one: require('../assets/images/one_single_select.png'),
                    two: require('../assets/images/two_single_select.png')
                }
            }
        },
        computed: {
            ...mapGetters([
                'getBusinessData'
            ])
        },
        methods: {
            ...mapMutations(['setBusinessData']),
            handleSelectPeople () {
                const data = {
                  one: "Diane",
                  two: "William",
                  three: "Bob"
                }

                this.$api.doPost("/dataMonitor/saveUseAmountData", {
                  dataName: data[this.imageIndex],
                  type: 2,
                });

                this.setBusinessData({peopleImage: this.imageIndex});
                this.$router.push('/introduce');
            },
            clickPeople (index) {
                if (!this.select) {
                    this.select = true;
                }
                this.imageIndex = index;
            },
            handlePrev () {
                this.$router.push('/home');
            }
        },
        created () {
            this.$emit('logo', true);
            this.$emit('prev', true);
        }
    }
</script>

<style lang="scss" scoped>
    .page {
        background: url('../assets/images/group_bg.jpg') no-repeat center top;
        background-size: cover;
        overflow: hidden;
    }

    @media only screen and (max-height: 700px) {
        .page {
            background-size: 100% 100%;
        }
    }

    .group-select-title {
        position: absolute;
        width: 50%;
        left: 25%;
        top: 14%;
    }

    .group-select, .hand-group-select {
        position: absolute;
        display: flex;
        bottom: 0;
        > div {
            flex: 1;
            z-index: 200;
        }

        img {
            width: 300%;
        }

        .one img {
            margin-left: -100%;
        }

        .two {
            z-index: 199;
            img {
                margin-left: -200%;
            }
        }
    }

    .select-cover {
        position: fixed;
        width: 100%;
        height: 100%;
        background: #000000;
        opacity: 0.5;
        z-index: 200;
    }

    .people-position {
        div {
            position: fixed;
            left: 0;
            width: 33%;
            height: 100%;
            z-index: 203;
        }

        .one {
            left: 33%;
        }

        .two {
            left: 67%;
        }
    }

    .select-btn {
        position: absolute;
        left: 40%;
        bottom: 3%;
        z-index: 204;
        img {
            width: 50%;
        }
    }
</style>
